// extracted by mini-css-extract-plugin
module.exports = {"heading":"styles-module--heading--Q75Ak","bodyText":"styles-module--bodyText--1EVHs","themeDark":"styles-module--themeDark--teUGB"};